import { useCallback, useEffect, useState } from 'react';
import { AppState } from 'react-native';
import { checkNotifications } from 'react-native-permissions';
import { isAndroid } from 'shared/src/utils';

export const useNotificationPermission = () => {
  const [isNotificationEnabled, setIsNotificationEnabled] =
    useState<boolean>(true);

  const checkPermission = useCallback(async () => {
    try {
      const { status } = await checkNotifications();
      setIsNotificationEnabled(status === 'granted');
    } catch (error) {
      console.log('checkNotifications 오류:', error);
    }
  }, []);

  useEffect(() => {
    checkPermission(); // 최초 진입 시

    const subscription = AppState.addEventListener('change', state => {
      if (state === 'active') {
        checkPermission(); // 백그라운드에서 돌아왔을 때 체크
      }
    });

    return () => subscription.remove();
  });

  return {
    isNotificationEnabled,
    openDeviceNotificationSettings: () => {
      if (isAndroid) {
        import('react-native').then(({ Linking }) => Linking.openSettings());
      } else {
        import('react-native-permissions').then(({ openSettings }) =>
          openSettings(),
        );
      }
    },
  };
};
